module.exports = __webpack_public_path__ + "img/8.336ca992.svg";